import { List, ListItem, OrderedList, Text, VStack } from '@chakra-ui/react';
import { Container } from '@/components/layouts/Container/Container';
import { Header } from '@/components/layouts/Header/Header';
import { SubHeader } from '@/components/layouts/SubHeader/SubHeader';
import { Wrapper } from '@/components/layouts/Wrapper/Wrapper';
import { Title } from '@/components/metas/Title/Title';

const TermsPage = () => {
  return (
    <Wrapper header={<Header title='利用規約' />}>
      <Title title='利用規約' />
      <Container>
        <SubHeader backTo='/' />
        <VStack spacing={6} my={6}>
          <Text fontWeight='bold' fontSize='lg'>
            利用規約
          </Text>
          <VStack spacing={4} alignItems='stretch'>
            <Text fontSize='sm'>
              この利用規約（以下「本規約」といいます）は、株式会社IMPRINT(以下「当社」といいます)が運営する「トレーニングシェア」の利用に関する条件を、本サービスを利用する法人、団体、組合又は個人と、当社との間で定めるものです。
            </Text>
            <Text fontSize='sm'>
              <Text fontWeight='bold'>第1条 定義</Text>
              本規約において使用する用語を以下の通り定めます。
              <OrderedList>
                <ListItem>
                  「会員」とは、本サービスを利用する全ての個人または法人を指します。
                </ListItem>
                <ListItem>
                  「本サービス」とは、当社が利用者に提供する「トレーニングシェア」に関する全てのサービスをいいます。本サービスの詳細は、当社が別途定めるところによります。
                </ListItem>
                <ListItem>
                  「コンテンツ」とは、当社が本サービス上に掲載する文章、表、画像・写真、イラスト、アイコン、キャラクター、ロゴ等の一切の情報を指します。
                </ListItem>
                <ListItem>
                  「アカウント」とは、本サービスに関して当社が定める利用単位を指します。
                </ListItem>
              </OrderedList>
            </Text>

            <Text fontSize='sm'>
              <Text fontWeight='bold'>第2条 本規約への同意</Text>
              <OrderedList>
                <ListItem>
                  会員は、本規約の定めに従って本サービスを利用しなければならず、本サービスを実際に利用することにより、本規約に有効かつ取消不能な同意をしたものとみなされます。
                </ListItem>
                <ListItem>
                  本サービスにおいて当社が掲載した注意事項等についても本規約の一部を構成するものとし、会員はこれらについても遵守しなければなりません。
                </ListItem>
                <ListItem>
                  会員が未成年の場合、予め親権者の承諾を得た上で、本サービスを利用するものとします。
                </ListItem>
              </OrderedList>
            </Text>

            <Text fontSize='sm'>
              <Text fontWeight='bold'>第3条 本規約の変更</Text>

              <OrderedList>
                <ListItem>
                  当社は、当社が必要と認めた場合に、本規約の内容を変更することができるものとします。
                </ListItem>
                <ListItem>
                  本規約を変更する場合、当社は、当社Webサイトへの掲示その他当社が適当と判断した方法により、あらかじめ変更後の本規約の内容及び効力発生時期を通知します。ただし、法令上会員の同意が必要となる変更を行う場合は、当社が適当と判断した方法により同意を得るものとします。なお、会員が効力発生日以後に本サービスを利用した場合には、法令上その効力を否定される場合を除き、変更後の本規約に同意したものとみなされます。
                </ListItem>
              </OrderedList>
            </Text>

            <Text fontSize='sm'>
              <Text fontWeight='bold'>第4条 本サービス利用環境の設定</Text>
              会員は、本サービスの利用にあたっては、自らの責任と負担において、その利用に必要となるハードウェア、ソフトウェア及びインターネット接続環境等、本サービスを利用するために必要となる一切の環境を設定し、整備するものとします。なお、ここにいう環境の設定と整備には、本サービスの品質を維持するために必要となるソフトウェアの更新を行うことを含みます。
            </Text>

            <Text fontSize='sm'>
              <Text fontWeight='bold'>第5条 利用料金</Text>
              <OrderedList>
                <ListItem>
                  会員は、利用するアカウントの数に応じ、本サービスの利用料金（以下「利用料金」といいます）として当社Webサイト等に別途掲載する金額を、当社所定の方法により、当社に対して支払うものとします。なお、利用料金の日割り計算は一切行われません。
                </ListItem>
                <ListItem>
                  当社は、いかなる理由があっても既に支払われた利用料金は一切返還しません。
                </ListItem>
                <ListItem>
                  会員は、本サービス利用の停止を行う場合、当社所定の期限までに、当社所定の方法により解約申請手続きを行う必要があります。会員が当該手続を完了しない限り、本サービスの利用期間は1ヶ月間自動で更新されるものとします。
                </ListItem>
                <ListItem>
                  会員が当社所定の期限までに利用料金をお支払いいただけない場合、年12%の割合による遅延損害金をお支払い頂くものとします。
                </ListItem>
              </OrderedList>
            </Text>

            <Text fontSize='sm'>
              <Text fontWeight='bold'>第6条 ID等の取扱い</Text>
              当社から会員に対してIDおよびパスワード等が付与された場合、会員はこれらのIDおよびパスワード等を第三者に開示・漏洩することのないよう必要かつ十分な注意義務をもって取り扱うものとし、IDおよびパスワードの管理不十分、使用上の過誤、第三者使用等による損害は、会員が負うものとします。
            </Text>

            <Text fontSize='sm'>
              <Text fontWeight='bold'>第7条 知的財産権の帰属等</Text>

              <OrderedList>
                <ListItem>
                  本サービスおよびコンテンツに関する著作権及びその他の知的財産権は、すべて当社又は正当な権利を有する第三者に帰属するものとし、会員には帰属致しません。
                </ListItem>
                <ListItem>
                  本サービスおよびコンテンツの一切につき、会員は無断で複製、譲渡、貸与、翻訳、改変、転載、公衆送信（送信可能化を含みます。）、伝送、配布、販売､提供､出版、営業使用等を行ってはなりません｡
                </ListItem>
              </OrderedList>
            </Text>

            <Text fontSize='sm'>
              <Text fontWeight='bold'>第8条 禁止事項</Text>
              <OrderedList>
                <ListItem>
                  会員は、本サービスの利用において以下の各号に定める行為をしてはならないものとします。
                  <List>
                    <ListItem>
                      (1) 利用料金を支払期日までに支払わないこと
                    </ListItem>
                    <ListItem>
                      (2)
                      1つのアカウントを第三者に対して利用させもしくは貸与し、または第三者との間で共有すること
                    </ListItem>
                    <ListItem>
                      (3)
                      法令、裁判所の判決、決定もしくは命令、または法令上拘束力のある行政措置への違反
                    </ListItem>
                    <ListItem>
                      (4) 公の秩序または善良の良俗を害すること
                    </ListItem>
                    <ListItem>
                      (5) 反社会的勢力に対する利益供与その他の協力をすること
                    </ListItem>
                    <ListItem>
                      (6)
                      犯罪による収益の移転行為およびこれを助長、幇助等すること
                    </ListItem>
                    <ListItem>
                      (7)
                      第三者へのなりすましまたは意図的に虚偽の情報を送信すること
                    </ListItem>
                    <ListItem>
                      (8)
                      当社、他の会員、その他第三者の権利を侵害し、または迷惑をかけること
                    </ListItem>
                    <ListItem>
                      (9) 不正アクセス行為、またはこれを助長する行為
                    </ListItem>
                    <ListItem>(10) 本サービスの誤作動を誘引すること</ListItem>
                    <ListItem>
                      (11)
                      本サービスが通常意図しないバグを利用する動作を生じさせ、または、通常意図しない効果を及ぼす外部ツールの利用、作成、または頒布
                    </ListItem>
                    <ListItem>
                      (12)
                      当社、他の会員のサーバー、コンピュータ等に過度の負担をかけること
                    </ListItem>
                    <ListItem>
                      (13)
                      当社、他の会員、その他第三者にコンピュータウイルス等の有害なプログラムを送信し、または流布すること
                    </ListItem>
                    <ListItem>(14) 本サービスの運営を妨げること</ListItem>
                    <ListItem>
                      (15) 不正な目的をもって、本サービスを利用すること
                    </ListItem>
                    <ListItem>
                      (16)
                      本規約に違反し、または、本サービスの趣旨目的に反すること
                    </ListItem>
                    <ListItem>(17) その他当社が不適切と判断すること</ListItem>
                  </List>
                </ListItem>
                <ListItem>
                  会員が前項の定めに違反した場合、当社は会員に事前に通知することなく、以下の各項に定める措置の一部または全部を講じることができます。
                  <List>
                    <ListItem>
                      (1)
                      会員による本サービスの利用を中止、停止、会員資格のはく奪をすること
                    </ListItem>
                    <ListItem>
                      (2)
                      会員に対し、会員が不当に得た利益に相当する金額の返還請求をすること
                    </ListItem>
                  </List>
                </ListItem>
                <ListItem>
                  前項の措置を講じたことによって会員に生じた損害については、当社は一切責任を負いません。
                </ListItem>
                <ListItem>
                  会員が第１項を含む本規約のいずれかの規定に違反したことにより当社に損害が生じた場合、会員は、当社に対し、当社に生じた全ての損害を賠償しなければならないものとします。
                </ListItem>
              </OrderedList>
            </Text>

            <Text fontSize='sm'>
              <Text fontWeight='bold'>第9条 譲渡禁止</Text>
              <OrderedList>
                <ListItem>
                  会員は、本サービスまたはアカウントの利用にかかる権利義務を第三者に譲渡、貸与してはなりません。
                </ListItem>
                <ListItem>
                  当社が本サービスに関する事業を第三者に譲渡した場合には、当該事業譲渡に伴い、本規約に基づく権利及び義務並び会員の登録事項その他の会員に関する情報を当該事業譲渡の譲受人に譲渡することができるものとし、会員は、係る譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他の事業が移転するあらゆる場合を含むものとします。
                </ListItem>
              </OrderedList>
            </Text>

            <Text fontSize='sm'>
              <Text fontWeight='bold'>第10条 免責</Text>
              <OrderedList>
                <ListItem>
                  本規約における当社の責任は合理的な努力をもって本サービスを運営することに限られるものとし、当社は本サービスの正確性、最新性、有用性、信頼性、適法性、特定目的への適合性、第三者の権利を侵害していないことを含め一切責任を負わず、またいかなる保証もなされません。
                </ListItem>
                <ListItem>
                  本サービスにおいて提供するコンテンツは、可能な限り安全面に留意しておりますが、会員は、自己の責任において体調管理を行うと共に安全面に配慮し、トレーニングを行っていただくものとします。本サービスは、コンテンツの提供を目的とするものであり、当社は、会員において実施したトレーニングの結果や事故等について、責任を負いません。
                </ListItem>
                <ListItem>
                  本サービスに関連して会員と会員の顧客等を含む第三者との間で生じるトラブル、その他の事項に対して、当社はいかなる責任を負わず、補償を行いません。
                </ListItem>
                <ListItem>
                  当社は、当社のウェブページ・サーバ・ドメインなどから送られるメール・コンテンツに、コンピュータウイルスなどの有害なものが含まれていないことを保証しません。
                </ListItem>
                <ListItem>
                  天災地変、戦争、テロ、暴動、法令・規則の制定改廃、政府機関の介入または命令、伝染病、停電、通信回線やコンピュータ等の障害・システムメンテナンス等による中断・遅滞・中止・データの消失、データの不正アクセス、輸送機関の事故、労働争議、設備の事故等の不可抗力等により、本サービスの一部または全部が停止する場合に会員に生じた損害について、当社は一切責任を負いません。
                </ListItem>
                <ListItem>
                  会員が本規約に違反したことによって生じた損害については、当社は一切責任を負いません。
                </ListItem>
                <ListItem>
                  本規約に定める免責条項が適用されない等の理由により当社が会員に対して責任を負うべき場合、当社に故意又は重過失がある場合を除き、それらの責任に基づく当社の損害賠償額は、会員が本サービスを利用するにあたって当社に対して支払った3か月分の利用料金に相当する金額（但し当該会員が支払った利用料金の金額がこれに満たない場合には会員が実際に支払った利用料金の合計金額とします。）を上限額とします。また、当社は、当社に故意又は重過失がある場合を除き、付随的損害、間接損害、特別損害、将来の損害及び逸失利益にかかる損害については、賠償する責任を負わないものとします。
                </ListItem>
              </OrderedList>
            </Text>

            <Text fontSize='sm'>
              <Text fontWeight='bold'>第11条 サービスの停止・終了</Text>
              当社は、事前に1ヶ月前までに会員に対して通知することにより、特定の会員または全ての会員に対して、本サービスまたは本サービスに付帯するサービスの提供を停止・終了することができるものとします。当社は、本サービスの停止・終了によって会員に生じた損害または不利益に対して一切責任を負いません。
            </Text>

            <Text fontSize='sm'>
              <Text fontWeight='bold'>第12条 暴力団等の反社会的勢力の排除</Text>
              <OrderedList>
                <ListItem>
                  当社及び会員は、本サービスの利用又は提供に際して、自身が暴力団、暴力団員、暴力団関係企業、総会屋、社会運動標ぼうゴロ、政治運動標ぼうゴロ、特殊知能暴力集団、その他反社会的勢力（以下｢暴力団等反社会的勢力｣といいます。）に所属又は該当せず、かつ、暴力団等反社会的勢力と関与していないことを表明し、将来にわたっても所属若しくは該当、又は関与しないことを確約するものとします。
                </ListItem>
                <ListItem>
                  当社は、会員が暴力団等反社会的勢力に所属若しくは該当する、又は関与していると判断した場合、事前に通知等を行うことなく、利用サービスの使用停止の措置、利用契約の解除をすることができます。会員は、当社が暴力団等反社会的勢力に所属若しくは該当する、又は関与していると判断した場合、事前に通知等を行うことなく、利用契約の解除をすることができます。
                </ListItem>
                <ListItem>
                  前項による解除の場合、解除をした当事者は相手方に対して解除による損害を賠償する義務を負いません。
                </ListItem>
              </OrderedList>
            </Text>

            <Text fontSize='sm'>
              <Text fontWeight='bold'>第13条 通知</Text>
              本サービスに関する当社から会員への通知等は、会員登録頂いたメールアドレス宛てへのメールの送信、ウェブサイト上への掲示、または、その他当社が適当と判断する方法によって行います。会員は、当社がこれらの通知等を行ってから24時間後に、当社からの通知が到達したとみなされることに、予め同意するものとします。
            </Text>

            <Text fontSize='sm'>
              <Text fontWeight='bold'>第14条 連絡・宣伝</Text>
              当社は、会員に対して、本サービスに関するヒアリング等するために、電話またはメールその他の方法により、ご連絡する場合がございます。当社は、会員に対して、法令等を遵守した上で、本サービスに関するキャンペーン告知、広告宣伝等のために、電話、メール、郵便その他の方法により、ご連絡する場合があります。
            </Text>

            <Text fontSize='sm'>
              <Text fontWeight='bold'>第15条 準拠法・管轄裁判所</Text>
              本規約は日本法に基づき解釈されるものとし、本規約に関し訴訟の必要が生じた場合には、訴額に応じ、東京簡易裁判所または東京地方裁判所を第一審の専属的合意管轄裁判所といたします。
            </Text>

            <Text fontSize='sm'>本規約は 2022 年 8月21日から適用します。</Text>
          </VStack>
        </VStack>
      </Container>
    </Wrapper>
  );
};

export default TermsPage;
